import React from 'react';
import PropTypes from 'prop-types';

import AddItemButton from '../../AddItemButton';

const OpenListEditorButton = (props) => (
  <AddItemButton onClick={props.toggleListEditor} ></AddItemButton>
);

OpenListEditorButton.propTypes = {
  toggleListEditor: PropTypes.func,
};

export default OpenListEditorButton;



// WEBPACK FOOTER //
// ./app/components/FormControls/ListEditor/OpenListEditorButton.js